<template>
        <section class="container mx-auto pt-16">
            <div class="text-center">
                <div class="clear--sm"></div>
                <h2 class="pb-4" v-text="$t('RESET_PASSWORD_RESET')"></h2>
                <p class="py-1" v-html="$t('RESET_PASSWORD_ALL_SET')"></p>
            </div>

            <div class="clear--sm"></div>

            <div class="w-full max-w-xs mx-auto">

                <email-address-field
                    :is-valid="!errorHandler.has('email')"
                    :message="errorHandler.get('email')"
                    :disabled="true"
                    v-model="email"/>

                <password-field
                    :require-strong-password="true"
                    :is-valid="!errorHandler.has('password')"
                    :message="errorHandler.get('password')"
                    v-model="password"/>

                <password-field
                    :require-strong-password="true"
                    :is-valid="!errorHandler.has('password_confirmation')"
                    :message="errorHandler.get('password_confirmation')"
                    label="Confirm your new password"
                    v-model="confirmPassword"/>

                <div class="text-center">
                    <submit-button @click="submitForm" v-html="$t('RESET_PASSWORD_UPDATE')"></submit-button>
                </div>
            </div>

            <div class="text-center">
                <div class="clear--sm"></div>
                <p class="py-1" v-html="$t('RESET_PASSWORD_SUPER_SECURE')"></p>
                <p class="py-1 mb-16" v-text="$t('RESET_PASSWORD_EG')"></p>
            </div>
    </section>
</template>

<script>
import { USER_TYPE } from '@/constants/Account';
import AuthService from '@/services/auth/AuthService';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import PasswordService from '@/services/auth/PasswordService';
import PasswordField from '@/components/forms/fields/PasswordField';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import EmailAddressField from '@/components/forms/fields/EmailAddressField';

let passwordService = new PasswordService();
let authService = new AuthService();

export default {
    name: 'ResetPassword',
    props: {
        token: {
            type: String,
        },
        messageEmail: {
            type: String,
        },
    },
    data() {
        return {
            isFormProcessing: false,
            email: null,
            password: null,
            confirmPassword: null,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    mounted() {
        this.email = this.messageEmail;
        passwordService.validateResetPasswordToken(this.token, this.messageEmail)
            .catch(() => {
                this.$router.push({ name: 'home' });
            });
    },
    methods: {
        requestToUpdatePassword() {
            passwordService.requestToUpdatePassword(this.email, this.password, this.confirmPassword, this.token)
                .then(() => {
                    this.authenticateUser(this.email, this.password);
                })
                .catch((error) => {
                    this.errorHandler.setResponse(error.response.data);
                    this.isFormProcessing = false;
                });
        },

        async authenticateUser(email, password) {
            this.$store.dispatch('auth/resetAuth');
            this.$store.dispatch('account/resetAccount');

            await authService.login(this.email, this.password)
                .then((response) => this.handleLoginSuccessResponse(USER_TYPE, response.data))
                .catch(() => console.log('login unsuccessful.'));
        },

        handleLoginSuccessResponse(userType, data = {}) {
            if (data.tokens) {
                localStorage.setItem('access_token', data.tokens.access_token);
                localStorage.setItem('refresh_token', data.tokens.refresh_token);
            }

            this.$store.dispatch('register/resetRegistrationProgress');
            this.$store.dispatch('auth/loginUser', USER_TYPE);

            this.$router.push({ name: 'account.dashboard' });
        },

        submitForm() {
            setTimeout(() => {
                this.requestToUpdatePassword();
            }, 1000);
        },
    },
    components: {
        EmailAddressField,
        SubmitButton,
        PasswordField,
    },
};
</script>
